// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"yatraGarden_scrollbar__3S0KX","date":"yatraGarden_date__2k57b"};